import { SafetyCertificateOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

export const Period = (props: {data: any, strike?: boolean}) => {  

  const color = props.strike ? 'darkred' : 'SeaGreen'

  let openTimeMinuteString= props.data.openTimeMinute.toString();
  let closeTimeMinuteString= props.data.closeTimeMinute.toString();
 
   return (
     <div>
         {props.strike ?
          <del style={{color: 'darkred', margin:'5px'}}>
           {props.data.openTimeHour}:{openTimeMinuteString.length > 1 ? props.data.openTimeMinute : "00" } - {props.data.closeTimeHour}:{closeTimeMinuteString.length > 1 ? props.data.closeTimeMinute : "00" }  
          </del>       
         :
          <p style={{color: 'SeaGreen', margin:'5px'}}>
           {props.data.openTimeHour}:{openTimeMinuteString.length > 1 ? props.data.openTimeMinute : "00" } - {props.data.closeTimeHour}:{closeTimeMinuteString.length > 1 ? props.data.closeTimeMinute : "00" } 
          </p>       
          }
     </div>
   )
 }

 export const PeriodReduced = (props: {data: any}) => {  
 
  let openTimeMinuteString= props.data.openTimeMinute.toString();
  let closeTimeMinuteString= props.data.closeTimeMinute.toString();
 
   return (
     <span>
         <span style={{color:'SeaGreen', margin:'5px 10px'}}>
           {props.data.openTimeHour}:{openTimeMinuteString.length > 1 ? props.data.openTimeMinute : "00" } - {props.data.closeTimeHour}:{closeTimeMinuteString.length > 1 ? props.data.closeTimeMinute : "00" } 
         </span>       
     </span>
   )
 }
